import { useQuery } from '@tanstack/react-query'

import { getCaseAlertListQuery } from '@/lib/queries/business/v1/alert/queries'

import { useFindTargetCase } from '../../hooks/use-find-target-case'

export const useCaseAlertList = ({ isEoir = false }: { isEoir?: boolean } = {}) => {
  const { targetCase } = useFindTargetCase({ isEoir })
  const caseId = targetCase?.case_id

  const { data: caseAlertList } = useQuery(getCaseAlertListQuery(caseId))

  return { caseAlertList }
}
